import type { Aoi } from "@/features/deployment-dashboard/live-view/model/aoi";
import type { AoiPopulations } from "@/features/deployment-dashboard/live-view/utils/derive-aoi-populations";

export const SECURITY_LANE_ACTIVATION_THRESHOLD = 3;

export type SecurityLaneState = "on" | "off" | "unavailable";

export interface SecurityLaneStatus {
  state: SecurityLaneState;
  peopleInside: number;
}

export type SecurityLaneStatuses = Readonly<Record<string, SecurityLaneStatus>>;

/** Derives the visual state for each system-managed security lane. */
export function deriveSecurityLaneStatuses(
  aois: readonly Aoi[],
  populations: AoiPopulations,
  threshold = SECURITY_LANE_ACTIVATION_THRESHOLD,
  hasFrame = true
): SecurityLaneStatuses {
  return Object.fromEntries(
    aois
      .filter((aoi) => aoi.aoiType === "security_lane")
      .map((aoi) => {
        const peopleInside = populations[aoi.id] ?? 0;
        return [
          aoi.id,
          (hasFrame
            ? {
                state: peopleInside > threshold ? "on" : "off",
                peopleInside,
              }
            : { state: "unavailable", peopleInside: 0 }) satisfies SecurityLaneStatus,
        ];
      })
  );
}
